/* eslint-disable */
import axios from 'axios';
import { getHeaderInfo, getImageHeaderInfo } from '@/helpers/ApiHeaders';
const handleResponse = (response) => {
    if ((response === null || response === void 0 ? void 0 : response.status) === 401) {
        // Token expired or invalid
        if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent('session-expired'));
        }
    }
    if ([200, 201, 302].includes(response === null || response === void 0 ? void 0 : response.status)) {
        return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
    }
    return Promise.reject(response === null || response === void 0 ? void 0 : response.data);
};
const makeApiRequest = async function (url, body, getHeaderFunc, // Updated type
method) {
    const header = await getHeaderFunc();
    try {
        const resp = await method(process.env.NEXT_PUBLIC_API_BASE_URL + url, body, header);
        return handleResponse(resp);
    }
    catch (err) {
        return handleResponse(err.response);
    }
};
export const post = async function (url, body) {
    return makeApiRequest(url, body, getHeaderInfo, axios.post);
};
export const postWithoutBody = async function (url) {
    const header = await getHeaderInfo();
    try {
        const resp = await axios.post(process.env.NEXT_PUBLIC_API_BASE_URL + url, undefined, // 👈 important
        header);
        return handleResponse(resp);
    }
    catch (err) {
        return handleResponse(err.response);
    }
};
export const patch = async function (url, body) {
    return makeApiRequest(url, body, getHeaderInfo, axios.patch);
};
export const get = async function (url, params) {
    const header = await getHeaderInfo();
    try {
        const resp = await axios.get(process.env.NEXT_PUBLIC_API_BASE_URL + url, Object.assign(Object.assign({}, header), { params }));
        return handleResponse(resp);
    }
    catch (err) {
        return handleResponse(err.response);
    }
};
export const deleteApi = async function (url) {
    const header = await getHeaderInfo();
    try {
        const resp = await axios.delete(process.env.NEXT_PUBLIC_API_BASE_URL + url, header);
        return handleResponse(resp);
    }
    catch (err) {
        return handleResponse(err.response);
    }
};
export const deleteWithParams = async function (url, params) {
    const header = await getHeaderInfo();
    try {
        const resp = await axios.delete(process.env.NEXT_PUBLIC_API_BASE_URL + url, Object.assign(Object.assign({}, header), { params }));
        return handleResponse(resp);
    }
    catch (err) {
        return handleResponse(err.response);
    }
};
export const put = async function (url, body) {
    const header = await getHeaderInfo();
    try {
        const resp = await axios.put(process.env.NEXT_PUBLIC_API_BASE_URL + url, body, header);
        return handleResponse(resp);
    }
    catch (err) {
        return handleResponse(err.response);
    }
};
export const postFormData = async function (url, body) {
    const header = await getImageHeaderInfo();
    try {
        const resp = await axios.post(process.env.NEXT_PUBLIC_API_BASE_URL + url, body, header);
        return handleResponse(resp);
    }
    catch (err) {
        return handleResponse(err.response);
    }
};
export const getImageApi = async function (url) {
    const header = await getHeaderInfo();
    try {
        const resp = await axios.get(process.env.NEXT_PUBLIC_API_BASE_URL + url, Object.assign(Object.assign({}, header), { responseType: 'arraybuffer' }));
        const extension = resp.headers['content-type'].split('/')[1];
        const blob = new Blob([resp.data], {
            type: `image/${extension}`,
        });
        return URL.createObjectURL(blob);
    }
    catch (err) {
        return handleResponse(err.response);
    }
};
